import { useParams } from 'react-router-dom';
import { Create as ApplicationGroupsCreate } from './ApplicationGroups/Create';
import { Create as ApplicationCreate } from './Applications/Create';
import { Create as ApplicationLinkCreate } from './ApplicationLinks/Create';
import { Create as ChatCreate } from './Chats/Create';
import { Create as ChatGroupsCreate } from './ChatsGroups/Create';
import { Create as ChatTemplateCreate } from './ChatsTemplates/Create';

export const AdminCreate = () => {
  const { resource } = useParams();

  switch (resource) {
    case 'applications':
      return <ApplicationCreate />;
    case 'application-groups':
      return <ApplicationGroupsCreate />;
    case 'application-links':
      return <ApplicationLinkCreate />;
    case 'chats':
      return <ChatCreate />;
    case 'chat-groups':
      return <ChatGroupsCreate />;
    case 'chat-templates':
      return <ChatTemplateCreate />;
    default:
      return <div>Resource not supported: {resource}</div>;
  }
};
